import React, { useEffect } from 'react'
import { menuItemsAllowed } from '../../../../services/permission/menus'
import { PageMenu } from '../../../../components'
import { IconCadastrosBlue } from '../../../../assets/imgs'
import NotAllowedModule from '../../../../components/NotAllowedModule/NotAllowedModule'
import { TpPermissions, verifyTpPermission } from '../../../../services/permission/menus'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

function DashboardMenu({ selectedTp }) {
  const [allowed, setAllowed] = React.useState(true)
  useEffect(() => {
    const allowed = verifyTpPermission(TpPermissions.DASHBOARD, selectedTp)
    setAllowed(allowed)
  }, [selectedTp])

  const menuItems = menuItemsAllowed([
    {
      id: 53,
      content: {
        menu: '1.1 - Status da Operações Logísticas',
        path: '/main/dashboard/status-operacoes-logisticas',
      },
    },
    { id: 54, content: { menu: '1.2 - Expedição TPs', path: '/main/dashboard/expedicao-tps' } },
    {
      id: 55,
      content: { menu: '1.3 - Cargas Paradas TPs', path: '/main/dashboard/cargas-paradas-tps' },
    },
    {
      id: 56,
      content: {
        menu: '1.4 - Devoluções Pendentes TPs',
        path: '/main/dashboard/devolucoes-pendentes-tps',
      },
    },
    {
      id: 57,
      content: {
        menu: '1.5 - Resultado por Empresa',
        path: '/main/dashboard/resultado-por-empresa',
      },
    },
    {
      id: 58,
      content: {
        menu: '1.6 - Produtividade Separação',
        path: '/main/dashboard/produtividade-separacao',
      },
    },
    {
      id: 59,
      content: {
        menu: '1.7 - Painel - Veículos em Rota',
        path: '/main/dashboard/painel-veiculos-em-rota',
      },
    },
    {
      id: 60,
      content: {
        menu: '1.8 - Acompanhamento Picking',
        path: '/main/dashboard/acompanhamento-picking',
      },
    },
    {
      id: 139,
      content: {
        menu: '1.9 - Painel de Monitoramento de Entregas',
        path: '/main/dashboard/painel-monitoramento-entregas',
      },
    },
    {
      id: 150,
      content: {
        menu: '1.10 - Produtividade de Expedição - Produto Estoque',
        path: '/main/dashboard/produtividade-expedicao',
      },
    },
  ])
  return (
    <>
      <PageMenu menuItems={allowed ? menuItems : []}>
        <img src={IconCadastrosBlue} alt="Icon Tela de Dashboard" />
        <span style={{ display: 'inline-block', marginLeft: 10 }}>1. Dashboard</span>
      </PageMenu>{' '}
      {!allowed && <NotAllowedModule />}
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(DashboardMenu))
